<template>
    <div id="equipmentPage">

    </div>
</template>
<script>
export default {
    name: 'equipmentPage',
    data() {
        return {

        };
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/equipmentPages/equipmentPage.vue